const Attachment = () => import('@/pages/system/attachment/attachment')

const CreateAttachment = () => import('@/pages/system/attachment/attachment/create')

export default {
  path: 'attachment',
  meta: {
    label: 'attachment',
    auth: 'attachment'
  },
  component: {
    name: 'Attachment',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemAttachmentReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Attachment
    },
    {
      name: 'SystemCreateAttachment',
      path: 'attachment/create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateAttachment
    }
  ]
}
